import flagus from "../assets/images/flags/us.svg";
import flagbr from "../assets/images/flags/br.svg";
import flages from "../assets/images/flags/es.svg";

/**
 * Locales F1 do produto (DOC 12) — sem demos Velzon extras no seletor.
 */
const languages = {
  "pt-BR": {
    label: "Português",
    flag: flagbr,
  },
  en: {
    label: "English",
    flag: flagus,
  },
  es: {
    label: "Español",
    flag: flages,
  },
};

export default languages;
